import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { FavoriteHollowIcon, FavoriteIcon } from 'foundations-assets';
import { useMutation } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ADD_FAVORITE, GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID, GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID, REMOVE_FAVORITE } from '../../queries';
import { useState } from 'react';
import { trackFavoriteRolloutButtonClick } from '../../../app/utils/tracking/tracking';
import { TrackingScreen, TrackingSubscreen } from '../../../app/utils/tracking/types';
import useUpdatePUTableCache from '../../hooks/useUpdatePUTableCache';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonWrapper = styled.div.withConfig({
  displayName: "FavoriteRolloutButton__ButtonWrapper",
  componentId: "sc-1eimlr8-0"
})(["display:flex;align-items:center;justify-content:center;padding-block-start:", ";> button{width:", ";margin-inline-end:", ";border:none;}"], ({
  theme
}) => theme.space['100'], ({
  theme
}) => theme.space['600'], ({
  theme
}) => theme.space['100']);
export function FavoriteRolloutButton({
  productUpdateId,
  rolloutId,
  initialIsFavorite
}) {
  const [isFavorite, setIsFavorite] = useState(initialIsFavorite);
  const {
    updateCache
  } = useUpdatePUTableCache();
  const [addFavorite, {
    loading: isAddingFavorite
  }] = useMutation(ADD_FAVORITE, {
    refetchQueries: [{
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID,
      variables: {
        id: productUpdateId
      }
    }, {
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID,
      variables: {
        id: rolloutId
      }
    }],
    update: () => {
      updateCache(productUpdateId, {
        isFavorite: true
      });
    },
    onCompleted: () => {
      trackFavoriteRolloutButtonClick({
        screen: TrackingScreen.PRODUCT_UPDATES,
        subscreen: TrackingSubscreen.UPDATE_PANEL,
        origin: 'panel',
        productUpdateId: `${productUpdateId}`,
        action: 'add favorite'
      });
    }
  });
  const [removeFavorite, {
    loading: isRemovingFavorite
  }] = useMutation(REMOVE_FAVORITE, {
    refetchQueries: [{
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_UPDATE_ID,
      variables: {
        id: productUpdateId
      }
    }, {
      query: GET_ROLLOUT_PRODUCT_UPDATE_BY_ROLLOUT_ID,
      variables: {
        id: rolloutId
      }
    }],
    update: () => {
      updateCache(productUpdateId, {
        isFavorite: false
      });
    },
    onCompleted: () => {
      trackFavoriteRolloutButtonClick({
        screen: TrackingScreen.PRODUCT_UPDATES,
        subscreen: TrackingSubscreen.UPDATE_PANEL,
        origin: 'panel',
        productUpdateId: `${productUpdateId}`,
        action: 'remove favorite'
      });
    }
  });
  const handleClick = () => {
    if (isAddingFavorite || isRemovingFavorite) {
      return;
    }
    if (isFavorite) {
      setIsFavorite(false);
      void removeFavorite({
        variables: {
          rolloutId
        }
      });
    } else {
      setIsFavorite(true);
      void addFavorite({
        variables: {
          rolloutId
        }
      });
    }
  };
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: isFavorite ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.detailsPanel.removeFavorite"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.detailsPanel.addFavorite"
      }),
      children: /*#__PURE__*/_jsx(IconButton, {
        use: "transparent",
        onClick: handleClick,
        size: "medium",
        paddingBlock: "0",
        disabled: isAddingFavorite || isRemovingFavorite,
        children: isFavorite ? /*#__PURE__*/_jsx(FavoriteIcon, {
          color: "icon-core-default",
          size: "500"
        }) : /*#__PURE__*/_jsx(FavoriteHollowIcon, {
          color: "icon-core-default",
          size: "500"
        })
      })
    })
  });
}